import React from 'react'
import Page from '../components/Page/Page'

const Dashboard = () => {
    return (
        <Page title="Dashboard">
            <div>Hello</div>
        </Page>
    )
}

export default Dashboard
